var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.142 12.142"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 314",
    d: "M5.071 1l7.071 5.071-7.071 5.071v-5.07z",
    fill: "#fff"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi4xNDIgMTIuMTQyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iUGF0aF8zMTQiIGRhdGEtbmFtZT0iUGF0aCAzMTQiIGNsYXNzPSJjbHMtMSIgZD0iTTEuNDE0LDEuNDE0LDEwLDAsOC41ODYsOC41ODYsNSw1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4wNzEgLTEpIHJvdGF0ZSg0NSkiLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };